<template>
  <div class="delivery-block">
    <header>
      <h3>Transporteur</h3>
    </header>

    <b-form-group>
      <b-form-radio-group
        v-model="data.transportId"
        :options="transports"
        :disabled="disabled || saving"/>
      <b-form-radio
        v-model="data.transportId"
        label="Anderes"
        :value="0"
        :disabled="disabled || saving">
        Anderes
      </b-form-radio>

      <div v-if="data.transportId === 0" class="mt-2">
        <b-input v-model="data.transport"/>
      </div>
    </b-form-group>
  </div>
</template>

<script>
import {computed, ref, watch} from '@vue/composition-api'
import ModalSelectFactory from "@/app/components/delivery/ModalSelectFactory.vue";

export default {
  components: {ModalSelectFactory},
  props: {
    value: { type: Object, required: true },
    context: { type: String, required: true },
    disabled: { type: Boolean, required: true },
    saving: { type: Boolean, required: true },
  },

  setup(props, { emit }) {
    const store = window.useStore()

    const data = ref(props.value)

    watch(data, () => {
      emit('change', data)
    }, { deep: true })

    const transports = computed(() => {
      return store.state.pwa.deliveries.piglet.config[props.context.toLowerCase() === 'piglet' ? 'transport' : 'transportAll'].data
        .map(t => ({
          text: t.name,
          value: t.id,
        }))
    })

    return {
      data,
      transports,
    }
  }
}
</script>
